import { ContextModalProps } from '@mantine/modals'
import {
  FabricVariantForm,
  PillowVariantForm,
  PremadeVariantForm,
  TableVariantForm,
  TowelVariantForm,
} from 'components/productDetails/VariantForm'
import { useAddProduct } from 'hooks/products'
import {
  Category,
  FabricVariant,
  FabricVariantFields,
  PillowVariant,
  PillowVariantFields,
  PremadeVariant,
  PremadeVariantFields,
  TableVariant,
  TableVariantFields,
  TowelVariant,
  TowelVariantFields,
  Unit,
} from 'types/products'

type Props = {
  productId: string
  category: Category
}

export default function EditVariantModal({
  context,
  id,
  innerProps: { productId, category },
}: ContextModalProps<Props>) {
  const addFabric = useAddProduct<FabricVariant>()
  const addPremade = useAddProduct<PremadeVariant>()
  const addPillow = useAddProduct<PillowVariant>()
  const addTowel = useAddProduct<TowelVariant>()
  const addTable = useAddProduct<TableVariant>()

  async function submitFabric(values: FabricVariantFields) {
    await addFabric.mutateAsync({
      ...values,
      productId,
      category: Category.FABRIC,
      size: values.size.toString(),
    })
  }

  async function submitPremade(values: PremadeVariantFields) {
    await addPremade.mutateAsync({
      ...values,
      productId,
      category: Category.PREMADE,
      size: `${values.width}x${values.height}`,
    })
  }

  async function submitPillow(values: PillowVariantFields) {
    await addPillow.mutateAsync({ ...values, productId, category: Category.PILLOW })
  }

  async function submitTowel(values: TowelVariantFields) {
    await addTowel.mutateAsync({
      ...values,
      productId,
      category: Category.TOWEL,
      size: `${values.width}x${values.length}`,
    })
  }

  async function submitTable(values: TableVariantFields) {
    await addTable.mutateAsync({
      ...values,
      productId,
      category: Category.TABLE,
      size: `${values.width}x${values.length}`,
    })
  }

  if (category === Category.FABRIC) {
    return (
      <FabricVariantForm
        actionType="add"
        onSubmit={submitFabric}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          size: undefined!,
          stock: undefined!,
          place: {
            shelf: undefined!,
            rack: undefined!,
            column: undefined!,
          },
          unit: Unit.METER,
          feature: undefined!,
          comments: undefined!,
        }}
      />
    )
  } else if (category === Category.PREMADE) {
    return (
      <PremadeVariantForm
        actionType="add"
        onSubmit={submitPremade}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          width: undefined!,
          height: undefined!,
          stock: undefined!,
          place: {
            shelf: undefined!,
            rack: undefined!,
            column: undefined!,
          },
          unit: Unit.PIECE,
          comments: undefined!,
          finish: [],
        }}
      />
    )
  } else if (category === Category.PILLOW) {
    return (
      <PillowVariantForm
        actionType="add"
        onSubmit={submitPillow}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          size: undefined!,
          stock: undefined!,
          place: {
            shelf: undefined!,
            rack: undefined!,
            column: undefined!,
          },
          unit: Unit.PIECE,
          feature: undefined!,
          comments: undefined!,
          pillowType: undefined!,
        }}
      />
    )
  } else if (category === Category.TOWEL) {
    return (
      <TowelVariantForm
        actionType="add"
        onSubmit={submitTowel}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          width: undefined!,
          length: undefined!,
          stock: undefined!,
          place: {
            shelf: undefined!,
            rack: undefined!,
            column: undefined!,
          },
          unit: Unit.PIECE,
          feature: undefined!,
          comments: undefined!,
        }}
      />
    )
  } else if (category === Category.TABLE) {
    return (
      <TableVariantForm
        actionType="add"
        onSubmit={submitTable}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          width: undefined!,
          length: undefined!,
          stock: undefined!,
          place: {
            shelf: undefined!,
            rack: undefined!,
            column: undefined!,
          },
          unit: Unit.PIECE,
          feature: undefined!,
          comments: undefined!,
          tableType: undefined!,
        }}
      />
    )
  }
}
